import { FetchState } from "@/shared/types";
import {
    LoginHistoryEvent,
    LoginHistoryState
} from "@/employer/types";
import * as UserService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: LoginHistoryState = {
    fetchState: FetchState.Uninitialized,
    history: []
};

export const useLoginHistoryStore = defineStore("loginHistory", {
    state: (): LoginHistoryState => (_.cloneDeep(initialState)),
    getters: {
        isLoading: state => state.fetchState === FetchState.Loading,
        isLoaded: state => state.fetchState === FetchState.Loaded,
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setHistory (history: LoginHistoryEvent[]) {
            this.history = history;
        },
        clearHistory () {
            this.history = [];
        },
        loadHistory (params: { partnerId: number, username: string }) {
            this.clearHistory();
            this.setFetchState(FetchState.Loading);

            UserService.getLoginHistory(params.partnerId, params.username)
                .then(response => {
                    this.setHistory(response.data.loginHistory);
                    this.setFetchState(FetchState.Loaded);
                })
                .catch(error => {
                    this.clearHistory();
                    this.setFetchState(FetchState.Uninitialized);
                    storeHelper.handleError({ error, rethrow: false });
                });
        }
    }
});
